import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import type {PopupAttrs} from '@jetbrains/ring-ui/components/popup/popup'
import classnames from 'classnames'
import type {ReactNode, SyntheticEvent, ReactElement} from 'react'
import {memo} from 'react'

import IconButton from '../../../common/IconButton/IconButton'

import styles from './ChangesDropdown.css'

function handleClick(event: SyntheticEvent) {
  event.preventDefault()
  event.stopPropagation()
}

type Props = {
  className?: string
  children: ReactElement<PopupAttrs> | ((props: Omit<PopupAttrs, 'children'>) => ReactNode)
  label: ReactNode
  noPopup?: boolean
  isPending?: boolean
  wrapperProps?: React.HTMLAttributes<HTMLElement>
}

function ChangesDropdown({className, children, label, noPopup, isPending, wrapperProps}: Props) {
  if (label == null) {
    return null
  }

  return (
    <div
      {...wrapperProps}
      className={classnames(className, styles.wrapper, styles.newUserInterfaceWrapper)}
      data-test={isPending ? 'pending-changes' : 'changes'}
    >
      <span className={styles.label}>{label}</span>
      {!noPopup && (
        <div role="presentation" onClick={handleClick}>
          <Dropdown
            className={styles.dropdown}
            data-test-changes-popup={'dropdown'}
            anchor={
              <IconButton
                className={styles.anchorIcon}
                icon="chevron-down"
                title=""
                aria-label="Changes popup"
              />
            }
            hoverMode
          >
            {children}
          </Dropdown>
        </div>
      )}
    </div>
  )
}

export default memo<Props>(ChangesDropdown)
